module.exports = __webpack_public_path__ + "static/img/5.ef43fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd103/5.png
// module id = rfh1
// module chunks = 1